import type { LayoutArea, TableLayout } from '@/domain/entities/table-layout.entity'
import type { Table, TableShape } from '@/domain/entities/table.entity'
import { TABLE_SHAPES } from '@/domain/entities/table.entity'
import type { LayoutAreaDto, TableDto, TableLayoutDto } from './table-layout.dto'

/** Bentuk asing dari BE tidak boleh membuat kanvas gagal gambar. */
function toShape(raw: string | null | undefined): TableShape {
  return TABLE_SHAPES.includes(raw as TableShape) ? (raw as TableShape) : 'square'
}

function toTable(dto: TableDto): Table {
  return {
    id: dto.id,
    name: dto.name,
    shape: toShape(dto.shape),
    x: dto.x ?? 0,
    y: dto.y ?? 0,
    seats: dto.seats ?? 0,
    isOccupied: dto.is_occupied ?? false,
    staticQrToken: dto.static_qr_token ?? '',
    dynamicQrToken: dto.dynamic_qr_token ?? undefined,
    dynamicQrExpiresAt: dto.dynamic_qr_expires_at ?? undefined,
    isDynamicQrActive: dto.is_dynamic_qr_active ?? false,
    activeTransactions: dto.active_transactions ?? [],
  }
}

function toArea(dto: LayoutAreaDto): LayoutArea {
  return {
    id: dto.id,
    name: dto.name,
    tables: (dto.tables ?? []).map(toTable),
  }
}

export const tableLayoutMapper = {
  toLayout(dto: TableLayoutDto, outletId: string): TableLayout {
    return {
      outletId: dto.outlet_id || outletId,
      version: dto.version ?? 0,
      areas: (dto.areas ?? []).map(toArea),
    }
  },

  /** Bentuk request `PUT /table-layout`. */
  toRequest(layout: TableLayout): Record<string, unknown> {
    return {
      outlet_id: layout.outletId,
      version: layout.version,
      areas: layout.areas.map((area) => ({
        id: area.id,
        name: area.name,
        tables: area.tables.map((table) => ({
          id: table.id,
          name: table.name,
          shape: table.shape,
          x: table.x,
          y: table.y,
          seats: table.seats,
        })),
      })),
    }
  },
}
